module.exports = __webpack_public_path__ + "img/class7.21502e6f.png";